import { Group, SimpleGrid, Stack, Title } from "@mantine/core";
import { useTRPC } from "../../trpc";
import { FormattedMessage, useIntl } from "react-intl";
import { SimpleBreadcrumbs } from "../../components/SimpleBreadcrumbs";
import { EChartTimeseries } from "../../components/EChartTimeseries";
import { useQuery } from "@tanstack/react-query";
import { startOfMonth } from "date-fns/startOfMonth";
import { endOfMonth } from "date-fns/endOfMonth";
import { useMemoizedBarSeries } from "../../hooks/chart.js";

export const Home = () => {
  const intl = useIntl();
  const trpc = useTRPC();
  const { data: newAccounts = [] } = useQuery(trpc.getNewAccounts.queryOptions());
  const { data: newUsers = [] } = useQuery(trpc.getNewUsers.queryOptions());
  const { data: cacheStats } = useQuery(trpc.getCacheStatsHistogram.queryOptions({
    from: startOfMonth(new Date()),
    to: endOfMonth(new Date()),
    interval: "day",
  }));

  const newAccountsSeries = useMemoizedBarSeries(newAccounts);
  const newUserSeries = useMemoizedBarSeries(newUsers);
  const cacheHitsSeries = useMemoizedBarSeries(cacheStats?.hits);
  const cacheMissesSeries = useMemoizedBarSeries(cacheStats?.misses);

  return (
    <Stack px="md" my="md">
      <SimpleBreadcrumbs
        parent={intl.formatMessage({ defaultMessage: "Admin", id: "navigation.admin" })}
        current={intl.formatMessage({ defaultMessage: "Dashboard", id: "navigation.dashboard" })}
        description={intl.formatMessage({ defaultMessage: "See high level project metrics", id: "text.projectsViewDescription" })}
      />

      <SimpleGrid
        cols={{ base: 1, lg: 2 }}
        spacing={{ base: 10, sm: "md" }}
        verticalSpacing={{ base: "md", sm: "xl" }}
      >
        <Stack>
          <Title size="h2">
            <FormattedMessage defaultMessage="New accounts" id="title.newAccounts" />
          </Title>
          <Group h="320px">
            <EChartTimeseries
              series={newAccountsSeries}
              xLabel="Date"
              yLabel="Count"
            />
          </Group>
        </Stack>
        <Stack>
          <Title size="h2">
            <FormattedMessage defaultMessage="New users" id="title.newUsers" />
          </Title>
          <Group h="320px">
            <EChartTimeseries
              series={newUserSeries}
              xLabel="Date"
              yLabel="New Users"
            />
          </Group>
        </Stack>
        <Stack>
          <Title size="h2">
            <FormattedMessage defaultMessage="Cache hits" id="title.cacheHits" />
          </Title>
          <Group h="320px">
            <EChartTimeseries
              series={cacheHitsSeries}
              xLabel="Date"
              yLabel="Cache hits"
            />
          </Group>
        </Stack>
        <Stack>
          <Title size="h2">
            <FormattedMessage defaultMessage="Cache misses" id="title.cacheMisses" />
          </Title>
          <Group h="320px">
            <EChartTimeseries
              series={cacheMissesSeries}
              xLabel="Date"
              yLabel="Cache misses"
            />
          </Group>
        </Stack>
      </SimpleGrid>
    </Stack>

  );
};
